import {axios, HOST, config} from './settiing';

export default {
  /* Refueling */
  getRefuelingBetween(start, end) {
    return axios.get(`${HOST}/resource/vehicle/refueling/${start}/${end}`, config)
  },

  addRefueling(data){
    return axios.post(`${HOST}/resource/vehicle/refueling`, data, config)
  },

  updateRefueling(data) {
    return axios.put(`${HOST}/resource/vehicle/refueling`, data, config);
  },

  getRefuelingList(vehicleId, notBefore, notAfter) {
    return axios.get(`${HOST}/resource/vehicle/refueling/${vehicleId}/${notBefore}/${notAfter}`, config);
  },

  deleteRefueling(id) {
    return axios.delete(`${HOST}/resource/vehicle/refueling/${id}`, config);
  },
}
